export const API_NAME = "ingredients";
export const ROUTE_NAME = "ingredients";
export const COMPONENT_NAMES = ["Ingredients", "Ingredients"];
